import App from 'app/app.js';
import 'app/directive/LtTextPersonalizerCtrl.js';

function LtTextPersonalizerDirective() {
  return {
    restrict: 'E',
    scope: {
      isAddOn: '=',
      orderLines: '=',
      orderLineDetail: '=',
      selectionTemplateMap: '=',
      quantity: '=',
      models: '=',
      editIndex: '=',
      imgSrc: '=',
      onGoBack: '&',
      onClickOfPersonalizerButton: '&',
      onUpdateQuantity: '&',
      onProcessQuantity: '&',
      showDiscountPrice: '=',
      isUpsell: '='
    },
    template:
      '<div class="row text-personalizer-container">' +
      '   <div class="visible-xs text-personalizer-mobile-title">' +
      '       <div class="col-xs-1 text-left text-personalizer-goback hidden-xs">' +
      '           <a ng-click="textPersonalizerCtrl.onGoBack()" data-id="text_link" ><lt-icon name="fa-sharp-solid-long-arrow-left" class="mara-blue f2"></lt-icon></a>' +
      '       </div>' +
      '       <div class="col-xs-12 text-center">' +
      '           <span class="mara-blue weight-600 f2" ng-bind="orderLineDetail.item | ItemDescFilter"></span>' +
      '       </div>' +
      '   </div>' +
      '   <div class="col-xs-12 col-sm-6 col-md-6 col-md-offset-1 text-center">' +
      '       <div>' +
      '           <img ng-src="{{imgSrc}}" alt="Product Image" class="text-personalizer-image" data-id="image_link" />' +
      '       </div>' +
      '       <span class="f6 mara-dark-grey" lt-translate="PERSONALIZER_DESCRIPTION"></span>' +
      '   </div>' +
      '   <div class="col-xs-12 col-sm-6 col-md-4 text-center">' +
      '       <h1 class="text-personalizer-title mara-blue weight-600 hidden-xs" ng-bind="orderLineDetail.item | ItemDescFilter"></h1>' +
      '       <div class="refreshed-plusminus" ng-show="editIndex < 0 && isAddOn">' +
      '           <a><lt-icon name="fa-sharp-solid-minus" ng-click="textPersonalizerCtrl.onUpdateQuantity(-1)" data-id="text_link" ></lt-icon></a>' +
      '           <input id="quantity" type="text" lt-key-filter="name" ng-model="quantity" ng-change="textPersonalizerCtrl.onProcessQuantity()"' +
      '               ng-blur="textPersonalizerCtrl.onProcessQuantity(1)" />' +
      '           <a><lt-icon name="fa-sharp-solid-plus" ng-click="textPersonalizerCtrl.onUpdateQuantity(1)" data-id="text_link" ></lt-icon></a>' +
      '       </div>' +
      '       <h2 ng-bind="(orderLineDetail.item.unitPrice * (orderLines.length||1) ) | CurrencyLocaleFilter"' +
      '           class="mara-blue weight-600"' +
      '           ng-class="{\'unitprice-strike\': showDiscountPrice}"' +
      '           ng-show="isAddOn"></h2>' +
      '       <h2 ng-bind="(orderLineDetail.item.discountedPriceWithPackage * (orderLines.length||1) ) | CurrencyLocaleFilter"' +
      '           class="mara-green weight-600"' +
      '           ng-if="showDiscountPrice"></h2>' +
      '       <div class="col-xs-10 col-xs-offset-1 text-personalizer-form">' +
      '           <form name="valForm" novalidate="novalidate">' +
      '              <div class="form-group" ng-repeat="field in selectionTemplateMap.fields.field">' +
      '                 <ng-form name="childForm">' +
      '                       <lt-selection-template-field dynamic-name="$index" ' +
      '                                                    model="models[$index]" ' +
      '                                                    selection-template-field="field" ' +
      '                                                    name-field-validation="true"' +
      '                                                    on-field-changed="textPersonalizerCtrl.onPersonalizationChanged()"' +
      '                                                    template-name="selectionTemplateMap.templateName"> ' +
      '                       </lt-selection-template-field>' +
      '                       <div ng-repeat="err in textPersonalizerCtrl.getFieldErrors(field.name)">' +
      '                           <p class="text-left f6 text-alert" ng-bind="err.msg"></p>' +
      '                       </div>' +
      '                  </ng-form>' +
      '              </div>' +
      '               <div class="cyop-btn-wrap"> ' +
      '                   <button ng-class="{\'disabled-add-to-cart-button\': textPersonalizerCtrl.isActionDisabled()}" ' +
      '                           class="lt-btn btn-lg btn-block cyop-btn" ' +
      '                           ng-click="textPersonalizerCtrl.onClickOfPersonalizerButton()"' +
      '                           ng-disabled="textPersonalizerCtrl.isActionDisabled()"' +
      '                           lt-translate="{{textPersonalizerCtrl.updateBtnLabelForCYOP()}}"' +
      '                           data-id="button"  ng-hide="isAddOn" data-test-personalization-save-btn>' +
      '                   </button>' +
      '               </div>' +
      '               <lt-shopping-flow-bar class="visible-xs visible-sm" ng-show="isAddOn"' +
      '                   [headline]="\'DONE_WITH_PERSONALIZATION\'"' +
      '                   [subheadline]="\'ADD_TO_CART_FOR\'"' +
      '                   [subheadline-params]="textPersonalizerCtrl.getStickyBarSubheadlineParams()"' +
      '                   [cta-label]="\'PACKAGE_DETAIL_ADD_TO_CART_2\'"' +
      '                   [disabled]="textPersonalizerCtrl.isActionDisabled()"' +
      '                   (continue-clicked)="textPersonalizerCtrl.onClickOfPersonalizerButton()">' +
      '               </lt-shopping-flow-bar>' +
      '               <button ng-class="{\'disabled-add-to-cart-button\': textPersonalizerCtrl.isActionDisabled()}" class="lt-btn btn-lg btn-block hidden-xs hidden-sm" ng-click="textPersonalizerCtrl.onClickOfPersonalizerButton()"' +
      '                   ng-disabled="textPersonalizerCtrl.isActionDisabled()"' +
      '                   lt-translate="ADD_TO_CART" data-id="button"  ng-show="isAddOn" data-test-personalization-save-btn>' +
      '               </button>' +
      '               <button class="lt-btn btn-lg btn-block" data-id="button"  ng-show="textPersonalizerCtrl.hasSystemErrorMessage()"' +
      '                   ng-click="textPersonalizerCtrl.onGoBack()" lt-translate="TEXT_PERSONALIZER_BACK">' +
      '               </button>' +
      '           </form>' +
      '       </div>' +
      '   <div class="clearfix"></div>' +
      '   <div class="text-personalizer-cancel"><a ng-click="textPersonalizerCtrl.onGoBack()" lt-translate="COMMON_TEXT_CANCEL" ></a></div>' +
      '   <p class="f5 mara-dark-grey" ng-bind="textPersonalizerCtrl.getProductDescription()"></p>' +
      '   </div>' +
      '</div>',
    controller: 'LtTextPersonalizerCtrl',
    controllerAs: 'textPersonalizerCtrl'
  };
}

App.directive('ltTextPersonalizer', [LtTextPersonalizerDirective]);
